/**
 * {PageRequirements}
 * @constructor
 */
var PageRequirements = function (config) {

    let self = this;
    /**
     *
     * @type {{PageRuleIsFor: {ServerConditionName: 'RequiredPage'}}}
     */
    self.config = {};

    self.finalPage = null;

    /**
     * add
     * @param uriPath
     * @param conditionName
     * @param requiredPage
     * @returns {PageRequirements}
     */
    self.add = function (uriPath, conditionName, requiredPage) {
        if (!self.config[uriPath]) {
            self.config[uriPath] = {};
        }
        self.config[uriPath][conditionName] = requiredPage;
        return self;
    };

    /**
     * getUriPath
     * @param uriPath
     * @param conditionName
     * @returns {*}
     */
    self.getUriPath = function (uriPath, conditionName) {
        if (!self.config[uriPath]) {
            return null;
        }

        if (!self.config[uriPath][conditionName]) {
            return null;
        }

        return self.config[uriPath][conditionName];
    };

    /**
     * getRequiredNextPage
     * @param currentPageUriPath
     * @param orderConditions
     * @returns {*}
     */
    self.getNextRequiredPage = function (currentPageUriPath, orderConditions) {
        let requiredPage;
        for (let i = 0, len = orderConditions.length; i < len; ++i) {

            requiredPage = self.getUriPath(currentPageUriPath, orderConditions[i].name);

            if (requiredPage !== null && requiredPage !== currentPageUriPath) {
                return requiredPage;
            }
        }

        return null;
    };

    /**
     * isPageRequired
     * @param currentPageUriPath
     * @param orderConditions
     * @returns {boolean}
     */
    self.isPageRequired = function (currentPageUriPath, orderConditions) {
        let requiredPage;
        for (let i = 0, len = orderConditions; i < len; ++i) {
            requiredPage = self.getUriPath(currentPageUriPath, orderConditions[i].name);

            if (requiredPage === currentPageUriPath) {
                return true;
            }
        }

        return false;
    };

    /**
     * init
     * @param config
     */
    let init = function (config) {
        self.config = config;
    };

    init(config);
};

/**
 * {PageRequirementsProvider}
 * @constructor
 */
var PageRequirementsProvider = function () {

    let self = this;

    self.config = {};

    self.add = function (uriPath, conditionName, requiredPage) {
        if (!self.config[uriPath]) {
            self.config[uriPath] = {};
        }
        self.config[uriPath][conditionName] = requiredPage;
        return self;
    };

    self.$get = [
        function () {
            return new PageRequirements(
                self.config
            );
        },
    ];
};

(function (angular) {

    let module = angular.module('checkout');

    let pageRequirementsProvider = new PageRequirementsProvider();

    /**
     * Provider config
     */
    module.provider(
        'pageRequirements',
        pageRequirementsProvider
    );

}(angular));
